export const driverAssignmentViews = {
    DISPATCH_ACTIVE: 'DISPATCH_ACTIVE',
    DISPATCH_INACTIVE: 'DISPATCH_INACTIVE',
};
